import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, GoogleLogo, ShieldCheck, Leaf, Info } from "@phosphor-icons/react";
import { useAuth } from "@/lib/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [privacyHint, setPrivacyHint] = useState(null);

  useEffect(() => {
    // If admin already logged in, jump straight to the admin home.
    if (user?.is_admin) navigate("/dashboard", { replace: true });
    const ua = (navigator.userAgent || "").toLowerCase();
    const isIosSafari =
      /iphone|ipad|ipod/.test(ua) && /safari/.test(ua) && !/crios|fxios/.test(ua);
    const isInAppBrowser = /fbav|instagram|line|wv\)/.test(ua);
    if (isInAppBrowser) {
      setPrivacyHint(
        'In-App-Browser blockieren manchmal Cookies. Falls der Login hängt: Menü → „Im Browser öffnen".'
      );
    } else if (isIosSafari) {
      setPrivacyHint(
        'iPhone-Tipp: Falls der Login hängt → Einstellungen → Safari → „Cross-Site-Tracking verhindern" kurz aus.'
      );
    }
  }, [user, navigate]);

  const onLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4" data-testid="login-root">
      <Helmet>
        <title>Admin-Zugang · bodenblick.com</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className="eid-card w-full max-w-md p-8">
        <Link to="/" className="text-xs text-zinc-400 flex items-center gap-1">
          <ArrowLeft size={12} /> Zur Info-Seite
        </Link>
        <div className="mt-6 flex items-center gap-3">
          <span className="p-2 rounded-sm bg-[#00FA9A]/10 text-[#00FA9A]">
            <Leaf size={22} />
          </span>
          <div>
            <div className="eid-label">bodenblick.com · Admin</div>
            <h1 className="text-2xl font-medium tracking-tight">Redaktions-Login</h1>
          </div>
        </div>
        <p className="text-sm text-zinc-400 mt-4">
          Dieser Bereich ist nur für die Bodenblick-Redaktion. Alle Inhalte
          sind öffentlich auf <Link to="/" className="underline">bodenblick.com</Link> einsehbar — ein
          User-Konto ist nicht nötig und nicht vorgesehen.
        </p>

        {privacyHint && (
          <div
            className="mt-4 flex items-start gap-2 text-[11px] bg-[#FFD700]/10 border border-[#E8D69B] rounded-sm px-3 py-2 text-[#E8CB6B]"
            data-testid="login-privacy-hint"
          >
            <Info size={12} className="shrink-0 mt-0.5" weight="fill" />
            <span>{privacyHint}</span>
          </div>
        )}

        <button
          onClick={onLogin}
          data-testid="login-google-btn"
          className="mt-6 w-full flex items-center justify-center gap-2 bg-[#F5F5F5] text-[#0A0A0A] hover:bg-[#333] transition-colors rounded-sm px-4 py-3 text-sm font-medium"
        >
          <GoogleLogo size={18} weight="bold" /> Mit Google anmelden
        </button>

        <div className="mt-6 flex items-start gap-2 text-xs text-zinc-500">
          <ShieldCheck size={14} className="mt-0.5 shrink-0 text-[#00FA9A]" />
          <p>
            DSGVO: Wir speichern E-Mail, Name und Foto deines Google-Kontos zur
            Authentifizierung. Keine Passwörter. Keine fremden User-Konten.
          </p>
        </div>
      </div>
    </div>
  );
}
